import * as AddToBasket from '@ori-events/add-to-basket';

import { RequestUrl } from '~/models';

interface BuyingURLandMethod {
  url: string;
  method: AddToBasket.Method;
}

export default (method?: AddToBasket.Method): BuyingURLandMethod => {
  switch (method) {
    case AddToBasket.Method.BUY_FOR_MONEY:
      return {
        url: RequestUrl.AddToBasketForMoney,
        method: AddToBasket.Method.BUY_FOR_MONEY,
      };
    case AddToBasket.Method.BUY_FOR_POINTS:
      return {
        url: RequestUrl.AddToBasketForPointsRewardShop,
        method: AddToBasket.Method.BUY_FOR_POINTS,
      };
    default:
      return {
        url: RequestUrl.AddToBasketCheckLoyalty,
        method: AddToBasket.Method.BUY_FOR_MONEY,
      };
  }
};
